import script from "./CompanyTypesSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyTypesSlider.vue?vue&type=script&setup=true&lang=js"

import "./CompanyTypesSlider.vue?vue&type=style&index=0&id=9a18e46c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a18e46c"]])

export default __exports__